"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenProvider = void 0;
const axios_1 = __importDefault(require("axios"));
const randomstring_1 = __importDefault(require("randomstring"));
const qs_1 = __importDefault(require("qs"));
const crypto_js_1 = require("crypto-js");
const build_url_1 = __importDefault(require("build-url"));
const buffer_1 = require("buffer");
const CONSTANTS = __importStar(require("./common/constants"));
const functions_1 = require("./common/functions");
class TokenProvider {
    constructor(clientConfig, logger = console) {
        this.instance = axios_1.default.create({
            baseURL: `https://${clientConfig.stage}.${clientConfig.region}.federated-auth.aft.a2z.com/${clientConfig.tenantId}`,
            timeout: clientConfig.timeout ? clientConfig.timeout : 1000,
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
        });
        this.clientConfig = clientConfig;
        this.logger = logger;
        buffer_1.Buffer.from('anything', 'base64');
        window.Buffer = window.Buffer || require('buffer').Buffer;
    }
    /**
     * Function to provide the authorization endpoint
     * @param loginHint a hint to the authentication server about the identity provider. Login hint is an indicator
     * of the idp selected/configured for a FIT client/tenant.
     * @param mtls When this argument is set to true, the function returns the authorization endpoint
     * for both mTLS device authentication and user authentication. Otherwise, it returns the authorization endpoint
     * for user authentication only.
     * @param promptLogin When set to true, fit-sso session cookie will be ignored and user will be redirected to
     * idp selection on every login attempt
     */
    getAuthUrl(loginHint = undefined, mtls = false, promptLogin = false) {
        this.logger.info(`Generating Auth URL with loginHint value: ${loginHint}`);
        const codeVerifier = randomstring_1.default.generate(128);
        sessionStorage.setItem(CONSTANTS.SESSION_STORAGE_CODE_VERIFIER_KEY, codeVerifier);
        const codeChallenge = this.generateCodeChallenge(codeVerifier);
        const url = this.buildFITAuthorizeUrl(codeChallenge.toString(), loginHint, mtls, promptLogin);
        this.logger.info("Generated url: " + url);
        return url;
    }
    generateCodeChallenge(codeVerifier) {
        return (0, crypto_js_1.SHA256)(codeVerifier).toString(crypto_js_1.enc.Base64url);
    }
    buildFITAuthorizeUrl(codeChallenge, loginHint = undefined, mtls, promptLogin) {
        const queryParams = {
            redirect_uri: this.clientConfig.callbackUrl,
            scope: `openId tenantId:${this.clientConfig.tenantId}`,
            response_type: 'code',
            client_id: this.clientConfig.clientId,
            code_challenge: codeChallenge,
            code_challenge_method: 's256',
        };
        if (loginHint) {
            queryParams['login_hint'] = loginHint;
        }
        if (promptLogin) {
            // With this param, fit-sso session cookie will be ignored and user will be redirected to idp selection
            // page on every login attempt
            queryParams['prompt'] = 'login';
        }
        const baseUrl = `https://${this.clientConfig.stage}.${this.clientConfig.region}.federated-auth.aft.a2z.com/${this.clientConfig.tenantId}`;
        const endpoint = mtls ? `${baseUrl}/mtls/authorize` : `${baseUrl}/authorize`;
        return (0, build_url_1.default)(endpoint, {
            queryParams: queryParams,
        });
    }
    storeAuthCode(code) {
        sessionStorage.setItem(CONSTANTS.SESSION_STORAGE_AUTH_CODE_KEY, code);
    }
    async getToken() {
        const authCode = sessionStorage.getItem(CONSTANTS.SESSION_STORAGE_AUTH_CODE_KEY);
        const codeVerifier = sessionStorage.getItem(CONSTANTS.SESSION_STORAGE_CODE_VERIFIER_KEY);
        if ((0, functions_1.isEmptyString)(authCode)) {
            const msg = "Fail to find auth code in session storage.";
            this.logger.error(msg);
            throw new Error(msg);
        }
        if ((0, functions_1.isEmptyString)(codeVerifier)) {
            const msg = 'Fail to find code verifier in session storage.';
            this.logger.error(msg);
            throw new Error(msg);
        }
        const data = {
            client_id: this.clientConfig.clientId,
            scope: `openId tenantId:${this.clientConfig.tenantId}`,
            grant_type: 'authorization_code',
            code: authCode,
            redirect_uri: this.clientConfig.callbackUrl,
            code_verifier: codeVerifier,
        };
        await this.requestToken(data);
    }
    async getUserInfo() {
        const accessToken = sessionStorage.getItem(CONSTANTS.SESSION_STORAGE_ACCESS_TOKEN_KEY);
        if ((0, functions_1.isEmptyString)(accessToken)) {
            const msg = "Fail to find access token in session storage.";
            this.logger.error(msg);
            throw new Error(msg);
        }
        const userInfo = await this.instance.get('/userinfo', {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        console.log("User data", userInfo.data);
        return userInfo.data;
    }
    async refreshToken() {
        const refreshToken = sessionStorage.getItem(CONSTANTS.SESSION_STORAGE_REFRESH_TOKEN_KEY);
        if ((0, functions_1.isEmptyString)(refreshToken)) {
            const msg = "Fail to find refresh token in session storage.";
            this.logger.error(msg);
            throw new Error(msg);
        }
        const data = {
            client_id: this.clientConfig.clientId,
            scope: `openId tenantId:${this.clientConfig.tenantId}`,
            grant_type: 'refresh_token',
            redirect_uri: this.clientConfig.callbackUrl,
            refresh_token: refreshToken,
        };
        await this.requestToken(data);
    }
    async requestToken(data) {
        return this.instance.post('/token', qs_1.default.stringify(data)).then((response) => {
            sessionStorage.setItem(CONSTANTS.SESSION_STORAGE_ACCESS_TOKEN_KEY, response.data.access_token);
            sessionStorage.setItem(CONSTANTS.SESSION_STORAGE_REFRESH_TOKEN_KEY, response.data.refresh_token);
            sessionStorage.setItem(CONSTANTS.SESSION_STORAGE_ID_TOKEN_KEY, response.data.id_token);
            sessionStorage.setItem(CONSTANTS.SESSION_STORAGE_EXPIRES_IN_KEY, response.data.expires_in);
            sessionStorage.setItem(CONSTANTS.SESSION_STORAGE_TOKEN_TYPE_KEY, response.data.token_type);
        });
    }
}
exports.TokenProvider = TokenProvider;
//# sourceMappingURL=tokenProvider.js.map